module.exports = __webpack_public_path__ + "static/media/money.352d09bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/instagram-promo/money.png
// module id = 2464
// module chunks = 7